class pgweb.ErrorDialog
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance
	
	show: (title, message, details) ->
		$('#error-dialog').popup()

		$('#error-dialog-title').html(title)
		$('#error-dialog-message').html(message)
		if details
			$('#error-dialog-details').show()
			$('#error-dialog-details p').html(details)
		else
			$('#error-dialog-details').hide()
		
		$('#error-dialog').popup 'open'

$(-> pgweb.ErrorDialog.inst())
